import React, { useMemo } from 'react';

import { useGetEvents } from '@vlabs/api/luna-api/client';
import type { Event } from '@vlabs/api/luna-api/model';

import { BaseMap } from './BaseMap';
import { getMarker } from './getMarker';

interface EventMapProps {
  event?: Event;
}

export function EventMap({ event = undefined }: EventMapProps): React.JSX.Element {
  const topMatchId = event?.top_match?.face_id ?? event?.top_match?.event_id;
  const { data: topMatchEvents } = useGetEvents({
    top_similar_object_ids: topMatchId ? [topMatchId] : undefined,
    page_size: 100,
  }, {
    query: { enabled: !!topMatchId },
  });

  const markers = useMemo(() => {
    const historyMarkers = (topMatchEvents?.events ?? [])
      .filter((historyEvent) => historyEvent.event_id !== event?.event_id)
      .map(getMarker)
      .filter((marker) => marker !== null);

    const currentMarker = getMarker(event);

    return currentMarker
      ? [...historyMarkers, currentMarker]
      : historyMarkers;
  }, [event, topMatchEvents?.events]);

  return (
    <BaseMap
      location={event?.location}
      markers={markers}
      streamId={event?.stream_id}
    />
  );
}
